module.exports = __webpack_public_path__ + "static/mr-press-01-6318798d89b66526fe4a9ebd967da107.jpg";